import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { LOGOS_URL } from '../../config';
import ExhibitorProgress from './ExhibitorProgress';
import logo from '../../assets/default.jpg';
import './ExhibitorCard.css';

// Карточка экспонента с логотипом и прогрессом заполнения профиля
const ExhibitorCard = ({ exhibitor }) => {
	const navigate = useNavigate();
	const { i18n } = useTranslation();
    const lang = i18n.language;

	return (
        <div
            className='ExhibitorCard' onClick={() => navigate('/cabinet/exhibitorview/' + exhibitor._id)}
        >
            <img
                alt='logo'
                className='Logo'
                src={exhibitor.logo ? LOGOS_URL + exhibitor.logo.base + exhibitor.logo.name : logo}
            />
            <div className='Name'>
                {exhibitor.name[lang]}
            </div>
            <ExhibitorProgress exhibitor={exhibitor}/>
            <div className='Event'>
                <Icon icon={faLocationDot}/>&nbsp;&nbsp;
                {exhibitor.event.name[lang]}
            </div>
        </div>
    );
};

ExhibitorCard.propTypes = {
    exhibitor: PropTypes.object.isRequired,
};

export default ExhibitorCard;
